<ion-card>
    <ion-card-content>
        <ion-fab vertical="center" horizontal="end" >
            <ion-fab-button (tap)="openModalDrawSignature()" size="small" color="light">
                <ion-icon name="create"></ion-icon>
            </ion-fab-button>
        </ion-fab>
        <label>{{ title }}</label>
    </ion-card-content>
    <ion-card-content *ngIf="document.signature || document.engineerSignature" class="content">
        <ion-img *ngIf="document.signature !== null && title === 'Signature'" [src]="document.signature"></ion-img>
        <ion-img *ngIf="document.engineerSignature !== null && title === 'Engineer Signature'"
                 [src]="document.engineerSignature"></ion-img>
    </ion-card-content>

</ion-card>
